import SuspendedUserModal from "components/Reusable/Modals/SuspendedUserModal.tsx";
import apiRequest from "../../../utils/ApiRequest/apiRequest.js";
import Form from "components/Reusable/Form/Form.js";
import sendMailToVerifyFields from "./sendMailToVerifyFields.ts";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useModal } from "../../../contexts/modalContext/modalContext.js";
import { useToasts } from "react-toast-notifications";

const SendMailToVerify = ({ userData }) => {
  const { getTextByKey, getLanguageCulture } = useContent();
  const { closeModal, setModal } = useModal();
  const { addToast } = useToasts();

  const RegistrationResendConfirmationEmail = async (formBody) => {
    const body = {
      RecaptchaResponse: formBody.recaptchaResponse,
      UserCulture: getLanguageCulture(),
    };
    const response = await apiRequest(
      "Users",
      "RegistrationResendConfirmationEmail",
      body,
      "POST"
    );
    if (response.status === "success") {
      if (response.data) {
        addToast(getTextByKey("send-email-verify-success"), {
          appearance: "success",
        });
      } else {
        addToast(getTextByKey("send-email-verify-error"), {
          appearance: "error",
        });
      }
    } else {
      if (response.status === "error") {
        const errMessage = response.data;
        if (errMessage === "Error #4200") {
          setModal({
            modal: SuspendedUserModal,
          });
        }
        return;
      } else {
        addToast(getTextByKey("send-email-verify-error"), {
          appearance: "error",
        });
      }
    }
    closeModal();
  };

  return (
    <div className="email-verify-modal">
      <div className="top-section">
        <div className="modal-content">
          <div className="modal-body">
            <Form
              fields={sendMailToVerifyFields}
              onSubmit={RegistrationResendConfirmationEmail}
              defaultValuesObj={{
                Email: userData.UserName,
              }}
              submitProps={{
                title: getTextByKey("ok"),
                className: "send-email-verify-button",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendMailToVerify;
